import React from 'react';
import { createLazyPage } from '../createLazyPage';
import { AppRouteDefinition } from '../routeDefinition';

const CashPaymentPage = createLazyPage(
  () => import('@app/modules/cashPayment/pages/CashPaymentPage')
);

export const cashPaymentRoutes: AppRouteDefinition[] = [
  {
    key: 'cash-payment',
    path: 'cash-payment',
    element: <CashPaymentPage />,
  },
];
